import React from 'react';

import { Text } from '@mantine/core';
import { GitbookIcon } from 'hugeicons-react';
import { OverviewCard } from 'pages/GuestSmartAssistant/GuestDashboard/OverviewTab/OverviewCard';
import { useTranslation } from 'react-i18next';
import { SmartAssistant } from 'shared/interfaces/SmartAssistant';

interface ResourcesOverviewProps {
  smartAssistant: SmartAssistant;
}

export function ResourcesOverview({ smartAssistant }: ResourcesOverviewProps) {
  const { t } = useTranslation();

  return (
    <OverviewCard title={t('SMART_ASSISTANT.OVERVIEW_SECTION.RESOURCES.TITLE')} icon={<GitbookIcon />}>
      <Text fw={600} size={25}>
        {smartAssistant.resources.length}
      </Text>
      <Text size="sm" c="dimmed">
        {t('SMART_ASSISTANT.OVERVIEW_SECTION.RESOURCES.UOM')}
      </Text>
    </OverviewCard>
  );
}
